import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const CommonClickAction = css`
  cursor: pointer;
  transition: transform 0.1s ease-out;
  :active {
    transform: scale(0.95);
  }
`;

export const CollapseAnimationStyles = (heigth: number): FlattenSimpleInterpolation => {
  return css`
    overflow: hidden;
    max-height: ${heigth}px;
    transition: 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-sizing: content-box;
  `;
};

export const GoToAnotherSection = styled.div`
  ${(props) => props.theme.typography.subHeader3};
  margin-bottom: 32px;
`;

export const GoToAnotherSectionLink = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.brand};
`;
